/**
 * @fileoverview Flow Editor Vuex mutations for managing state.
 * @module store/modules/floweditor/mutations
 */

import { MutationTree } from "vuex/types";
import Vue from "vue";
import { FlowContent, FlowEditorState, Flows, FlowTrigger } from "./types";
import _ from "lodash";

const mutations: MutationTree<FlowEditorState> = {
  /**
   * Sets the fetching flows loading state.
   *
   * @param {FlowEditorState} state - Current module state
   * @param {boolean} payload - Loading state value
   */
  SET_FETCHING_FLOWS(state, payload: boolean) {
    Vue.set(state, "fetchingFlows", payload);
  },
  /**
   * Sets all flows in the state.
   *
   * @param {FlowEditorState} state - Current module state
   * @param {Flows} payload - Flows object keyed by flowId
   */
  SET_FLOWS(state, payload: Flows) {
    Vue.set(state, "flows", payload);
  },
  /**
   * Sets flow content nodes.
   *
   * @param {FlowEditorState} state - Current module state
   * @param {FlowContent} payload - Flow content object
   */
  SET_FLOW_CONTENT(state, payload: FlowContent) {
    Vue.set(state, "contents", payload);
  },
  /**
   * Sets flow triggers.
   *
   * @param {FlowEditorState} state - Current module state
   * @param {FlowTrigger} payload - Flow trigger object
   */
  SET_FLOW_TRIGGER(state, payload: FlowTrigger) {
    Vue.set(state, "triggers", payload);
  },
  /**
   * Deletes a flow by ID.
   *
   * @param {FlowEditorState} state - Current module state
   * @param {string} payload - Flow ID to delete
   */
  DELETE_FLOW(state, payload) {
    const _flows = _.cloneDeep(state.flows);
    delete _flows[payload];
    Vue.set(state, "flows", _flows);
  },
  /**
   * Adds a new flow to the state.
   *
   * @param {FlowEditorState} state - Current module state
   * @param {Object} payload - Flow object with flowId property
   */
  ADD_FLOW(state, payload) {
    console.log(payload);
    const _flows = _.cloneDeep(state.flows);
    _flows[payload.flowId] = payload;
    Vue.set(state, "flows", _flows);
  },
  // ADD_FLOW_SECTION(state, payload) {
  //   console.log(payload)
  //   let _flows = _.cloneDeep(state.flows);
  //   _flows[payload.flow.flowId].sections.push(payload.section)
  //   Vue.set(state, "flows", _flows);
  // }
};

export default mutations;
